import { Box, TextField } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CustomTypography from "./CustomTypography"; // Adjust path as needed
import theme from "../../assets/theme";

const StyledTextField = ({ label, disabled, ...props }) => {
  const inputBoxStyle = {
    "& .MuiOutlinedInput-root": {
      borderRadius: theme.borderRadius.medium,
      backgroundColor: disabled
        ? theme.palette.lightgray.light // Set your desired disabled bg color
        : theme.palette.lightgray.main,
      "& fieldset": {
        borderColor: theme.palette.gray.main,
      },
      "&:hover fieldset": {
        borderColor: disabled
          ? theme.palette.gray.main
          : theme.palette.primary.main,
      },
      "&.Mui-focused": {
        backgroundColor: disabled
          ? theme.palette.lightgray.light
          : theme.palette.light.main,
        "& fieldset": {
          borderColor: disabled
            ? theme.palette.gray.main
            : theme.palette.primary.main,
        },
      },
    },
  };

  return (
    <Box>
      {label && (
        <CustomTypography
          variant="bodyText1"
          display="block"
          gutterBottom
          color="dark.main"
        >
          {label}
        </CustomTypography>
      )}
      <TextField
        size="small"
        fullWidth
        disabled={disabled}
        sx={inputBoxStyle}
        {...props}
      />
    </Box>
  );
};

export default StyledTextField;
